import React from "react";
import "../css/user.css";

function UserMine({ email, role}) {
    return (
        <div className="user">
            <p id="emailuser" className="textlink UserField"><b>Email:</b> {email}</p>
            <p id="roleuser" className="textlink UserField"><b>Role:</b> {role}</p>
            <div className="DeleteButtonSpace"></div>
        </div>
    );
}

export default UserMine;
